import { postJobApiCall } from '../../utils/jobRequest';
import {
  VALIDATE_DYNAMIC_VOICE_CODE_FAILURE,
  VALIDATE_DYNAMIC_VOICE_CODE_REQUEST,
  VALIDATE_DYNAMIC_VOICE_CODE_SUCCESS,
} from '../Types/types';

export const validateDynamicVoiceCode = (voice_call_session_id, verification_code) => async (dispatch) => {
  dispatch({ type: VALIDATE_DYNAMIC_VOICE_CODE_REQUEST });
  try {
    const res = await postJobApiCall("dynamic-voice-call/validate-code", {
      voice_call_session_id,
      verification_code,
    });
    dispatch({ type: VALIDATE_DYNAMIC_VOICE_CODE_SUCCESS, payload: res.data.data });
    return { success: true };
  } catch (error) {
    dispatch({ type: VALIDATE_DYNAMIC_VOICE_CODE_FAILURE });
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      (error?.response?.status === 403
        ? "Insufficient credits. Please contact your administrator."
        : "Invalid verification code or Insufficient credits. Please contact your administrator.");

    return { success: false, message };
  }
};
